module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am216-7b0f0aab5fa64164f2f2bcb40e12e774.jpg";